module.exports = __webpack_public_path__ + "static/ssb-bg-391c606225c00bbfaa7be5223a1d05a4.jpg";